import * as React from "react";
import classNames from "classnames";

import classes from "./Description.styl";
import {useGlobalModule} from "@ok/web/hooks/useGlobalModule";
import {BottomSheet} from "@ok/web/components/base/BottomSheet/BottomSheet";
import {DESCRIPTION_TEXT_LENGTH_FOR_OPEN_IN_BOTTOMSHEET} from "../../../../config";


interface IDescription {
    text: string;
}
export const Description = (props: IDescription) => {
    const viewport = useGlobalModule(() => window.OK.Viewport).current;

    const [isBsOpen, setBsOpen] = React.useState(false);
    const [textExpand, setExpand] = React.useState(false);

    const descriptionRef = React.useRef<HTMLSpanElement>(null);

    React.useEffect(() => {
        const description = descriptionRef.current;
        if (!description) {
            return;
        }
        if (!textExpand) {
            /*
                Уменьшение -webkit-line-clamp во время анимации ведет к отсутствию плавности или вообще к прерыванию.
                Чтобы избежать этого, откладываем его до окончания анимации.
             */
            setTimeout(() => {
                changeDescription(description, 2);
            }, 600);
        } else {
            changeDescription(description,  viewport?.isPortraitMode() ? 10 : 5);
        }
    }, [viewport, textExpand]);

    const handleExpand = () => {
        setExpand((prevState) => !prevState);
    };

    const changeDescription = (description: HTMLElement, rows: number) => {
        // @ts-ignore
        description.style['-webkit-line-clamp'] = rows;
    };

    const cnDescription = classNames(
        classes["description"],
        {
            [classes["__open"]]: textExpand,
            [classes["__close"]]: !textExpand,
        }
    );

    return (
        props.text.length > DESCRIPTION_TEXT_LENGTH_FOR_OPEN_IN_BOTTOMSHEET ?
            <>
                <span className={cnDescription} onClick={() => setBsOpen(true)}>
                    {props.text}
                </span>
                <BottomSheet
                    open={isBsOpen}
                    portalClassName={"clips-fullscreen"}
                    withPadding={true}
                    onClose={() => setBsOpen(false)}
                >
                    <div className={classes["description__bottomSheet-text"]}>
                        {props.text}
                    </div>
                </BottomSheet>
            </>
            :
            <span className={cnDescription} ref={descriptionRef} onClick={handleExpand}>
                {props.text}
            </span>
    );
};
